/* src/app/tree/tree.component.scss */
:host {
  display: block;
  height: 100%;
}
.tree-node {
  min-height: 100%;
  margin-top: 5px;
  border-radius: 4px;
  transition: background-color 0.2s;
}
.tree-node.cdk-drop-list-dragging .tree-item-container:not(.cdk-drag-placeholder) {
  transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);
}
.highlight-zone {
  background-color: #e3f2fd;
  border: 2px dashed #2196f3;
  min-height: 40px;
}
.tree-item-container {
  margin-bottom: 5px;
  position: relative;
}
.tree-item-container.has-menu-open {
  z-index: 10;
}
.tree-item-container.cdk-drag-dragging {
  opacity: 1;
}
.tree-item-container.cdk-drag-dragging button {
  pointer-events: none;
}
.route-transfer-copy {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
  margin-left: 10px;
  flex: 1;
}
.sidebar-reorder-content {
  margin-left: 8px;
  max-width: none;
  flex: 1;
  font-size: 13px;
  line-height: 1.45;
}
.tree-item .sidebar-reorder-content + .tree-actions {
  margin-left: 8px;
}
.route-transfer-title {
  font-size: 13px;
  font-weight: 600;
  color: inherit;
}
.route-transfer-preview {
  font-size: 12px;
  color: #64748b;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: left;
}
.inline-editor-field {
  display: grid;
  gap: 6px;
}
.inline-editor-field-wide {
  width: 100%;
}
.inline-editor-label {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #64748b;
}
.inline-editor-select,
.inline-editor-textarea,
.inline-prop-input {
  width: 100%;
  border: 1px solid #d9e0e7;
  border-radius: 10px;
  background: #fff;
  color: #0f172a;
  font: inherit;
}
.inline-editor-select,
.inline-prop-input {
  height: 38px;
  padding: 0 12px;
}
.inline-editor-textarea {
  min-height: 112px;
  padding: 10px 12px;
  resize: vertical;
}
.inline-text-editor {
  flex: 1;
  display: grid;
  gap: 10px;
  margin-left: 10px;
}
.inline-row-textarea {
  width: 100%;
  min-height: 84px;
  padding: 10px 12px;
  border: 1px solid #d9e0e7;
  border-radius: 10px;
  background: #fff;
  color: #0f172a;
  font: inherit;
  field-sizing: content;
  resize: none;
}
.inline-edit-note {
  padding: 10px 12px;
  border: 1px dashed #d9e0e7;
  border-radius: 10px;
  background: #f8fafc;
  color: #64748b;
  font-size: 13px;
}
.advanced-settings-popup {
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  width: min(420px, 100vw - 64px);
  padding: 16px;
  border: 1px solid #d9e0e7;
  border-radius: 14px;
  background: #fff;
  box-shadow: 0 18px 40px rgba(15, 23, 42, 0.16);
  z-index: 50;
}
.advanced-settings-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 14px;
  font-size: 13px;
  font-weight: 700;
  color: #0f172a;
}
.advanced-settings-grid {
  display: grid;
  gap: 14px;
}
.inline-properties-list {
  display: grid;
  gap: 10px;
}
.inline-prop-row {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) auto;
  gap: 8px;
  align-items: center;
}
.inline-editor-actions {
  margin-top: 10px;
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}
.inline-secondary-btn,
.inline-primary-btn,
.inline-icon-btn {
  border-radius: 10px;
  font: inherit;
  cursor: pointer;
}
.inline-secondary-btn,
.inline-primary-btn {
  height: 36px;
  padding: 0 14px;
  border: 1px solid #d9e0e7;
  display: inline-flex;
  align-items: center;
  gap: 8px;
}
.inline-secondary-btn {
  background: #fff;
  color: #334155;
}
.inline-primary-btn {
  background: #111827;
  border-color: #111827;
  color: #fff;
}
.inline-icon-btn {
  width: 36px;
  height: 36px;
  border: 1px solid #d9e0e7;
  background: #fff;
  color: #64748b;
}
.inline-icon-btn.danger:hover {
  color: #b91c1c;
  border-color: #fecaca;
  background: #fef2f2;
}
.tree-item {
  border: 1px solid #ddd;
  background: white;
  padding: 10px;
  border-radius: 4px;
  cursor: default;
  display: flex;
  align-items: center;
  color: black;
}
.tree-item .item-tag-wrap {
  flex-shrink: 0;
  position: relative;
  margin-right: 5px;
}
.tree-item .item-tag {
  max-width: 140px;
  border: 1px solid #ddd;
  padding: 2px 5px;
  border-radius: 4px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: center;
}
.tree-item .item-tag-btn {
  cursor: pointer;
  background: transparent;
  font: inherit;
  font-size: 11px;
  display: block;
}
.tree-item .item-tag-btn:hover,
.tree-item .item-tag-btn.active {
  border-color: #2196f3;
  background: #e3f2fd;
  color: #1565c0;
}
.tree-item .item-tag-btn.tag-changed {
  background: #fff9c4;
  border-color: #f0c040;
  color: #7a5500;
}
.tree-item .item-tag-btn.tag-changed:hover,
.tree-item .item-tag-btn.tag-changed.active {
  background: #fff3a0;
  border-color: #2196f3;
  color: #1565c0;
}
.tree-item .tag-picker-popup {
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  z-index: 100;
  background: #fff;
  border: 1px solid #ddd;
  border-radius: 8px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.14);
  min-width: 160px;
  max-height: 240px;
  overflow-y: auto;
  padding: 4px;
}
.tree-item .tag-picker-option {
  display: block;
  width: 100%;
  padding: 6px 10px;
  text-align: left;
  background: transparent;
  border: 0;
  border-radius: 5px;
  font: inherit;
  font-size: 12px;
  color: #334155;
  cursor: pointer;
  white-space: nowrap;
}
.tree-item .tag-picker-option:hover {
  background: #f1f5f9;
}
.tree-item .tag-picker-option.selected {
  background: #e3f2fd;
  color: #1565c0;
  font-weight: 600;
}
.tree-item .item-content {
  text-align: left;
  margin-left: 10px;
  max-width: 600px;
}
.tree-item .editable-content.can-inline-edit {
  cursor: text;
}
.tree-item:active {
  cursor: default;
}
.tree-item.drag-placeholder {
  opacity: 0.6;
  outline: 2px dashed #7aa7ff;
}
.tree-item.editing-active {
  background-color: #e3f2fd;
  border-color: #2196f3;
}
.tree-item.deleted {
  background-color: #fff1f3;
}
.tree-item.deleted .item-content {
  text-decoration: line-through;
  color: #888;
}
.tree-item.new-item {
  background-color: #e8f5e9;
  color: #2e7d32;
  font-style: italic;
}
.tree-item.modified-item {
  background-color: #fff9c4;
  color: #bf360c;
  border-left: 3px solid #ffca28;
}
.tree-item.moved-item {
  box-shadow: inset 5px 0px 0 0px #2196fe;
}
.drag-handle-btn,
.icon-action-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border: 0;
  border-radius: 8px;
  background: transparent;
  color: #64748b;
  transition: background-color 0.15s ease, color 0.15s ease;
}
.drag-handle-btn {
  flex-shrink: 0;
  margin-right: 4px;
  cursor: grab;
  opacity: 0;
  pointer-events: none;
}
.drag-handle-btn:active {
  cursor: grabbing;
}
.drag-handle-btn:hover,
.icon-action-btn:hover {
  background: #f3f4f6;
  color: #111827;
}
.tree-item:hover .drag-handle-btn,
.tree-item.editing-active .drag-handle-btn,
.tree-item-container.cdk-drag-dragging .drag-handle-btn {
  opacity: 1;
  pointer-events: auto;
}
.add-element-btn {
  background: none;
  border: 1px dashed #ccc;
  color: #666;
  border-radius: 4px;
  padding: 5px 10px;
  margin-top: 5px;
  font-size: 12px;
  cursor: pointer;
  width: 100%;
  text-align: left;
}
.add-element-btn:hover {
  background-color: #f8f8f8;
  border-color: #999;
  color: #333;
}
.toggle-btn {
  background: none;
  border: none;
  cursor: pointer;
  margin-right: 8px;
  font-size: 12px;
  width: 20px;
  display: flex;
  justify-content: center;
}
.children-container {
  padding-left: 20px;
  margin-left: 10px;
}
.cdk-drag-preview {
  box-sizing: border-box;
  border-radius: 4px;
  box-shadow:
    0 5px 5px -3px rgba(0, 0, 0, 0.2),
    0 8px 10px 1px rgba(0, 0, 0, 0.14),
    0 3px 14px 2px rgba(0, 0, 0, 0.12);
  background-color: white;
  padding: 10px;
  opacity: 0.8;
  display: flex;
  align-items: center;
}
.drag-placeholder {
  background: #eee;
  border: 1px dashed #999;
  min-height: 40px;
  margin-bottom: 5px;
  border-radius: 4px;
}
.source-shadow-placeholder {
  background-color: #f0f0f0;
  border: 1px dashed #ccc;
  opacity: 0.5;
  filter: grayscale(100%);
  display: flex;
  align-items: center;
  padding: 10px;
}
.cdk-drag-animating {
  transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);
}
.cdk-drag-placeholder {
  opacity: 1 !important;
}
.source-ghost {
  opacity: 0.55;
  outline: 2px dashed #7aa7ff;
}
.drag-ghost {
  display: none;
}
.drag-ghost.ghost-dragging {
  display: flex;
  opacity: 0.5;
}
.ghost-dragging {
  display: block;
}
::ng-deep .highlight {
  background-color: yellow;
  font-weight: bold;
}
.tree-actions {
  margin-left: auto;
  display: flex;
  flex-direction: row;
  gap: 4px;
  align-items: center;
}
.page-height-chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 2px 8px;
  border-radius: 999px;
  background: rgba(0, 0, 0, 0.05);
  font-size: 11px;
  color: #64748b;
  white-space: nowrap;
  cursor: default;
}
.page-height-chip .chip-meter {
  width: 44px;
  height: 4px;
  border-radius: 999px;
  background: rgba(0, 0, 0, 0.1);
  overflow: hidden;
}
.page-height-chip .chip-meter-fill {
  display: block;
  height: 100%;
  border-radius: 999px;
  background: #2b6e49;
}
.page-height-chip .chip-value {
  font-variant-numeric: tabular-nums;
}
.page-height-chip .chip-over {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-weight: 600;
}
.page-height-chip.over {
  background: #fdecec;
  color: #a13232;
}
.page-height-chip.over .chip-meter-fill {
  background: #c43737;
}
.action-icon {
  font-size: 12px;
  opacity: 1;
  transition: opacity 0.2s;
  -webkit-user-select: none;
  user-select: none;
}
.action-icon.props-icon {
  margin-left: 4px;
  margin-right: 2px;
}
.route-dropdown {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: white;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  max-height: 66.67vh;
  overflow-y: auto;
}
.route-option {
  padding: 8px 12px;
  cursor: pointer;
  font-size: 13px;
  color: #333;
  text-align: left;
}
.route-option:hover {
  background-color: #f0f0f0;
}
/*# sourceMappingURL=tree.component.css.map */
